/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A single tier in the Streak Bonus curve
 * @export
 * @interface StreakMultiplierTier
 */
export interface StreakMultiplierTier {
    /**
     * Minimum streak length to activate this tier
     * @type {number}
     * @memberof StreakMultiplierTier
     */
    minStreak: number;
    /**
     * Multiplier value (e.g., 1.5 for 50% boost)
     * @type {number}
     * @memberof StreakMultiplierTier
     */
    multiplier: number;
}

/**
 * Check if a given object implements the StreakMultiplierTier interface.
 */
export function instanceOfStreakMultiplierTier(value: object): value is StreakMultiplierTier {
    if (!('minStreak' in value) || value['minStreak'] === undefined) return false;
    if (!('multiplier' in value) || value['multiplier'] === undefined) return false;
    return true;
}

export function StreakMultiplierTierFromJSON(json: any): StreakMultiplierTier {
    return StreakMultiplierTierFromJSONTyped(json, false);
}

export function StreakMultiplierTierFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakMultiplierTier {
    if (json == null) {
        return json;
    }
    return {
        
        'minStreak': json['minStreak'],
        'multiplier': json['multiplier'],
    };
}

export function StreakMultiplierTierToJSON(json: any): StreakMultiplierTier {
    return StreakMultiplierTierToJSONTyped(json, false);
}

export function StreakMultiplierTierToJSONTyped(value?: StreakMultiplierTier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minStreak': value['minStreak'],
        'multiplier': value['multiplier'],
    };
}

